import React, { FC, useRef, useState } from "react";
import Link from "next/link";
import { useLocale, useTranslations } from "next-intl";
import { getCountrySpecificUrl } from "../utils/authNavItems";
import { ArrowDownIcon } from "@/components/assets/icons";
import { useOutsideClickDetector } from "@/hooks/useOutsideClickDetector";

type TProps = {
  name: string;
  list: {
    name: string;
    href: Record<string, string>;
  }[];
  countryCode: any;
};

const NavbarDropdown: FC<TProps> = ({ name, list, countryCode }) => {
  const t = useTranslations();
  const locale = useLocale();

  const [isOpened, setIsOpened] = useState(false);
  const ref = useRef(null);

  useOutsideClickDetector(ref, () => {
    setIsOpened(false);
  });

  return (
    <div ref={ref} onClick={() => setIsOpened(!isOpened)} className="relative">
      <div className="flex cursor-pointer items-center gap-2">
        <p className="text-lg">{name}</p>
        <ArrowDownIcon />
      </div>
      {isOpened && (
        <div className="w-ffull absolute left-0 top-[24px] z-20 rounded-lg bg-white p-4 shadow-lg">
          <ul className="flex flex-col gap-4">
            {list
              .filter((item) => item.href[countryCode] !== null)
              .map((item, index) => (
                <li key={index}>
                  <Link
                    href={getCountrySpecificUrl(
                      countryCode,
                      item.href[countryCode],
                      locale,
                    )}
                    target="_blank"
                    className="text-nowrap font-normal text-black"
                  >
                    {t(item.name)}
                  </Link>
                </li>
              ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default NavbarDropdown;
